module.exports = __webpack_public_path__ + "img/icon-activity-meeting-active.620a40a9.svg";